import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PartnerService} from '../../../services/partner.service';
import {MixpanelService} from '../../../services/mixpanel.service';
import {UserModel} from '../../../models/User';
import {AuthService} from '../../../services/auth.service';
import {UserService} from '../../../services/user.service';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InputMask} from 'primeng/inputmask';
import {environment} from '../../../../environments/environment';
import {Memberships} from '../../../services/subscription.service';
import {filter, take, tap} from 'rxjs/operators';
import {buildSrcset, LcpImagePreloadService} from '../../../services/image-preload-helper.service';

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding-layout.component.html',
    styleUrls: ['./onboarding-layout.component.scss', '../../signup/signup.scss']
})
export class OnboardingComponent implements OnInit{
    @ViewChild(InputMask) phoneMask!: InputMask;

    loading = false
    partnerLogoUrl: string;
    partnerId: string;
    user: UserModel;
    phoneForm: FormGroup;
    private returnUrl: string;

    constructor(private router: Router, private partnerService: PartnerService, private mixpanel: MixpanelService, private route: ActivatedRoute, private auth: AuthService, private userService: UserService, fb: FormBuilder, private imagePreloader: LcpImagePreloadService) {
        this.phoneForm = fb.group({
            phone: ['', [Validators.required, phoneDigitsValidator]],
            smsConsent: [false, Validators.requiredTrue]
        });

    }

    ngOnInit(): void {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || environment.dashboardUrl;
        const dec = Math.random()
        const base = '/assets/images/signup/PhonePage';
        this.imagePreloader.preload({
            id: 'phone-hero',
            href: `${base}-800.webp`,
            srcset: buildSrcset(base),
            sizes: "(min-width: 1580px) 570px, calc(33.33vw + 50px)"
        });
        this.partnerService.partnerInfoSubject.subscribe(partner => {
            if (partner) {
                this.partnerLogoUrl = partner.logoUrl;
                this.partnerId = partner.name;
            } else {
                this.partnerLogoUrl = '';
            }
        });
        this.auth.user$.pipe(
            filter((user): user is UserModel => !!user),
            take(1),
            tap(user => {
                this.user = user;
                if(this.user.phone){
                    this.phoneForm.get('phone')?.setValue(user.phone);
                }
                this.mixpanel.identify(user.id.toString());
                this.mixpanel.track('Phone Number Page Visited');
                const plan = this.route.snapshot.queryParams['plan'];
                if (plan === Memberships.PremiumPlus) {
                    this.addViralSweepScript(environment.viralSweepsURL1);
                    this.addViralSweepScript(environment.viralSweepsURL2);
                }
                else if (plan === Memberships.Free) {
                    const props = {
                        email:    user.email,
                        plan_selected: Memberships.Free,
                        partner_id:    this.partnerId
                    };
                    this.mixpanel.track('Plan Selected', props);
                    this.mixpanel.track('Started waitlist', props);
                }
            })
        ).subscribe();
    }

    moveCursorToStart() {
        const inputEl: HTMLInputElement = this.phoneMask.inputViewChild.nativeElement;
        setTimeout(() => inputEl.setSelectionRange(1, 1), 0);
    }

    submit(): void {
        this.loading = true;
        if (this.phoneForm.get('phone').invalid) {
            this.loading = false;
            this.navigateToReturnUrl();
            return;
        }
        if (this.phoneForm.get('smsConsent').invalid) {
            this.loading = false;
            this.phoneForm.get('smsConsent').markAsTouched();
            return;
        }
        const phone = this.phoneForm.value.phone;
        this.userService.update({ id: this.user.id, phone }).subscribe({
            next: _ => {
                this.loading = false;
                this.navigateToReturnUrl();
            },
            error: _ => {
                this.loading = false;
                this.navigateToReturnUrl();
            }
        });
    }

    private navigateToReturnUrl(): void {
        const url = new URL(this.returnUrl, window.location.origin);
        window.location.href = url.toString();
    }


    private addViralSweepScript(tagUrl: string) {
        function vs_get_cookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].trim();
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        }
        var vs_eidhash = vs_get_cookie('vseid');
        var vs_tag_url = `${tagUrl}?h=` + vs_eidhash;
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = vs_tag_url;
        head.appendChild(script);

    }
}
function phoneDigitsValidator(control: AbstractControl) {
    const digits = (control.value || '').replace(/\D/g, '');
    return digits.length === 10 ? null : { phoneDigits: true };
}
